import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import Datetime from 'react-datetime';
import moment, {Moment} from 'moment';
import 'moment/min/locales';

const locale = window.navigator.language.toLowerCase();
moment.locale(locale);

export interface RangeDateTimePickerProps {
    title: string;
    onChangeDateFrom: (v?: Date) => void;
    onChangeDateTo: (v?: Date) => void;
    fromValue?: Date | null;
    toValue?: Date | null;
}


export const RangeDateTimePicker: FunctionComponent<RangeDateTimePickerProps> = observer((props) => {
    return <div className="grid grid-flow-col auto-cols-max">
        {props.title && <div>
            {props.title}
        </div>}
        <div>
            <Datetime
                key={props.title + 'from' + props.fromValue?.getDate}
                closeOnSelect={true}
                value={props.fromValue as Date}
                className="ml-2 mr-2 w-40"
                utc={true}
                dateFormat={moment.localeData(locale).longDateFormat('L')}
                timeFormat={moment.localeData(locale).longDateFormat('LT')}
                inputProps={{onKeyDown: (e) => e.preventDefault()}}
                onChange={(v => props.onChangeDateFrom(typeof v === 'object' ? (v as Moment).toDate() : undefined))}
            />
        </div>
        <div>
            -
        </div>
        <div><Datetime
            key={props.title + 'to' + props.fromValue?.getDate()}
            closeOnSelect={true}
            value={props.toValue as Date}
            className="ml-2 w-40"
            dateFormat={moment.localeData(locale).longDateFormat('L')}
            timeFormat={moment.localeData(locale).longDateFormat('LT')}
            inputProps={{onKeyDown: (e) => e.preventDefault()}}
            onChange={(v => props.onChangeDateTo(typeof v === 'object' ? (v as Moment).toDate() : undefined))}
        /></div>

    </div>;
});
